import { SystemServiceErrorCodKeyEnum } from '@model/enum/system-services-error-msg';

export class DictionaryError {

  public static ERROR_DICTIONARY = [
    {
      cod: 1001, service_wf: 'brokerServiceAccountList', service_wso2: 'brokerServiceAccountList', service_adapter: '', method: '', error: [
        { cod: SystemServiceErrorCodKeyEnum.empty, cod_key: 'empty', error_service: '[]', desc_error: 'Conta não retornada no serviço ou modo "Market Data" desabilitado', desc_front: '1001-1' },
        { cod: SystemServiceErrorCodKeyEnum.unautorized, cod_key: 'unautorized', error_service: '401', desc_error: 'Usuário sem permissão de acesso no serviço', desc_front: '1001-2' },
      ]
    },
    {
      cod: 1002, service_wf: '', service_wso2: '', service_adapter: '', method: 'connectedAs', error: [
        { cod: SystemServiceErrorCodKeyEnum.error, cod_key: 'error', error_service: '0', desc_error: 'Tipo de usuário do sistema não encontrado/inválido ou modo "Market Data" desabilitado', desc_front: '1002-1' }
      ]
    },
    {
      cod: 1003, service_wf: '', service_wso2: '', service_adapter: 'info', method: '', error: [
        { cod: SystemServiceErrorCodKeyEnum.error, cod_key: 'error', error_service: '500', desc_error: 'Erro interno na API', desc_front: '1003-1' }
      ]
    },
    {
      cod: 1004, service_wf: '', service_wso2: '', service_adapter: 'token', method: '', error: [
        { cod: SystemServiceErrorCodKeyEnum.error, cod_key: 'error', error_service: '500', desc_error: 'Erro interno na API', desc_front: '1004-1' }
      ]
    },
    {
      cod: 1005, service_wf: 'refresh_token', service_wso2: 'refresh_token', service_adapter: 'refresh_token', method: '', error: [
        { cod: SystemServiceErrorCodKeyEnum.error, cod_key: 'error', error_service: '400 / 401', desc_error: 'Erro ao renovar o token', desc_front: '1005-1' }
      ]
    },
    {
      cod: 1006, service_wf: '', service_wso2: '', service_adapter: '', method: 'loadPredefinedWorkspaces', error: [
        { cod: SystemServiceErrorCodKeyEnum.empty, cod_key: 'empty', error_service: '[]', desc_error: 'Workspace padrão não encontrado', desc_front: '1006-1' }
      ]
    },
    {
      cod: 1007, service_wf: '', service_wso2: '', service_adapter: '', method: 'addWks', error: [
        { cod: SystemServiceErrorCodKeyEnum.error, cod_key: 'error', error_service: '[]', desc_error: 'Erro ao adicionar o workspace pro usuário', desc_front: '1007-1' }
      ]
    },
    {
      cod: 1008, service_wf: 'afcSearchQuestions', service_wso2: '', service_adapter: '', method: 'getAfcSearchQuestions', error: [
        { cod: SystemServiceErrorCodKeyEnum.error, cod_key: 'error', error_service: '401', desc_error: 'Usuário sem permissão', desc_front: '1008-1' }
      ]
    },
    {
      cod: 1009, service_wf: '', service_wso2: '', service_adapter: 'tokenOrSessionStorage', method: '', error: [
        { cod: SystemServiceErrorCodKeyEnum.error, cod_key: 'error', error_service: '[]', desc_error: 'TOKEN ou SESSAO não encontrado', desc_front: '1009-1' }
      ]
    },
    {
      cod: 1010, service_wf: 'terms_use/terms', service_wso2: 'terms_use/terms', service_adapter: 'terms_use/terms', method: '', key: 'terms_use_invalid_token', error: [
        { cod: SystemServiceErrorCodKeyEnum.unautorized, cod_key: 'unautorized', error_id: 'terms_use_invalid_token', error_service: '401', desc_error: 'Usuário sem permissão de acesso no serviço', desc_front: '1010-2' },
      ]
    },
    {
      cod: 1011, service_wf: 'terms_use/sign', service_wso2: 'terms_use/sign', service_adapter: 'terms_use/sign', method: '', key: '', error: [
        { cod: SystemServiceErrorCodKeyEnum.unautorized, cod_key: 'unautorized', error_id: 'terms_use_invalid_token', error_service: '401', desc_error: 'Usuário sem permissão de acesso no serviço', desc_front: '1011-2' },
      ]
    },
    {
      cod: 1012, service_wf: '', service_wso2: '', service_adapter: '', method: 'getConfigWhitelabel()', key: '', error: [
        { cod: SystemServiceErrorCodKeyEnum.empty, cod_key: 'empty', error_id: '', error_service: '[]', desc_error: 'Configuração da corretora não encontrada.', desc_front: '1012-1' },
      ]
    },
    {
      cod: 1013, service_wf: 'loginDuplicated', service_wso2: '', service_adapter: '', method: '', error: [
        { cod: SystemServiceErrorCodKeyEnum.internoLogin, cod_key: 'internoLogin', error_id: '', error_service: '[]', desc_error: 'Autenticado em outra plataforma', desc_front: '1013-3' },
      ]
    },
    {
      cod: 1014, service_wf: '', service_wso2: '', service_adapter: '', method: 'valideToken', error: [
        { cod: SystemServiceErrorCodKeyEnum.invalid, cod_key: 'invalid', error_id: '', error_service: '[]', desc_error: 'Autenticado em outra plataforma', desc_front: '1014-5' },
      ]
    },
    {
      cod: 1015, service_wf: 'subscriptionDifusion', service_wso2: '', service_adapter: '', method: 'statusWebSocket', error: [
        { cod: SystemServiceErrorCodKeyEnum.error, cod_key: 'error', error_id: '', error_service: 'ERROR', desc_error: 'Falha na conexão com socket', desc_front: '1015-1' },
      ]
    },
    {
      cod: 1016, service_wf: '', service_wso2: '', service_adapter: '', method: 'onReconnect', error: [
        { cod: SystemServiceErrorCodKeyEnum.error, cod_key: 'error', error_id: '', error_service: '400 / 401 / 110', desc_error: 'Erro no reconect com Socket', desc_front: '1016-1' }
      ]
    },
    {
      cod: 1017, service_wf: '', service_wso2: '', service_adapter: 'validate_token', method: 'validateTokenAdapter', error: [
        { cod: SystemServiceErrorCodKeyEnum.error, cod_key: 'error', error_id: '', error_service: '400 / 401', desc_error: 'Erro ao validar o token', desc_front: '1017-1' }
      ]
    }
  ];
}


